module.exports = __webpack_public_path__ + "img/PL08200.4a755f28.png";